import { render } from "./BankDetails.vue?vue&type=template&id=5fc762f6&scoped=true"
import script from "./BankDetails.vue?vue&type=script&lang=js"
export * from "./BankDetails.vue?vue&type=script&lang=js"

import "./BankDetails.vue?vue&type=style&index=0&id=5fc762f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc762f6"]])

export default __exports__